import React from 'react';

import cn from 'classnames'
import Image from 'next/legacy/image';
import Link from 'next/link'

import Icon from '@components/Icon'
import { MARKET_PATHS } from '@constants/index'
import { Button } from '@element/index';
import I18n from '@utils/i18n';

import styles from './index.module.less';

const CollectEmpty = ({
  className
}) => {
  return (
    <div className={cn(styles.emptyContain, className)}>
        <div className={styles.emptyImg}>
          <Image
            src={require('@images/noCollect.webp')}
            width={210}
            height={210}
            layout='fixed'
            alt={'kikitrade'}
          />
        </div>
    <div className={styles.emptyText}>{I18n.t('O6LpKz6n')}</div>
    <Link legacyBehavior href={`${MARKET_PATHS.MARKET}?activeKey=1`} passHref>
      <Button type='primary' className={styles.addButtom}>
        <div className={styles.btnContent}>
            <Icon name='addButtom' className={styles.icon} />
            <span>{I18n.t('re51dqno')}</span>
        </div>
      </Button>
    </Link>
    </div>
  );
}

export default CollectEmpty
